const SQFT_IN_ONE_ACRE = 43560;

export default class NumberHelper {
  static toShortNumber(stringNumber) {
    const ONE_THOUSAND = 1000;
    const ONE_MILLION = 1000000;
    const number = parseInt(stringNumber, 10);

    if (number >= ONE_MILLION) return `${(number / ONE_MILLION).toFixed(1)}M`;
    if (number >= ONE_THOUSAND) return `${(number / ONE_THOUSAND).toFixed(0)}K`;

    return number;
  }

  static sqftToAcres(sqftValue, accuracy) {
    return parseFloat((sqftValue / SQFT_IN_ONE_ACRE).toFixed(accuracy));
  }

  static acresToSqft(acresValue) {
    return parseInt(acresValue * SQFT_IN_ONE_ACRE, 10);
  }

  static indexNumberToOrderText(index) {
    const MIN = 0;
    const MAX = 10;
    const WORDS = [
      'First',
      'Second',
      'Third',
      'Fourth',
      'Fifth',
      'Sixth',
      'Seventh',
      'Eighth',
      'Ninth',
      'Tenth',
    ];

    if (index < MIN || index > MAX) {
      return null;
    }

    return WORDS[index];
  }
}
